import React from 'react';
import { AccomodationV2, GICV2 } from '../icons';
// interface GetVasStatusTagsStylingReturnProp {
//   containerClass: string;
//   textClass: string;
// }
function getVasStatusTagsStyling(status) {
    // const baseClass = 'lfc-rounded-full lfc-px-2 lfc-py-1 lfc-border-[0.5px]';
    switch (status) {
        case 'PENDING':
        case 'REQUEST_INITIATED':
        case 'ON_HOLD':
        case 'NO_RESPONSE':
        case 'DOCUMENTS_PENDING':
        case 'DEFERRED':
            return 'warning';
        case 'CANCELLED':
        case 'CANNOT_BE_FULFILLED':
        case 'REJECTED':
        case 'NOT_INTERESTED':
            return 'error';
        case 'REQUEST_FULFILLED':
        case 'REQUEST_GUARANTEED':
        case 'APPROVED':
        case 'DISBURSED':
        case 'DONE':
        case 'LOGIN':
            return 'success';
        default:
            return 'primary';
    }
}
function getVASRequestCardContent(type) {
    var baseIconContainerClass = 'lfc-rounded-lg lfc-p-3 lfc-border';
    switch (type) {
        case 'accomodation':
            return {
                defaultTitleText: 'Request for Accomodation',
                defaultSubTitleText: "Discover the best accommodations suited to your student's preferences and needs.",
                defaultIcon: React.createElement(AccomodationV2, null),
                defaultIconContainerClass: "".concat(baseIconContainerClass, " lfc-border-secondaryVariant-200 lfc-bg-secondaryVariant-100"),
                defaultFeatureProposition: [
                    'Tailored housing options based on preferences',
                    'Safe and verified accommodations',
                    'Earn a commission of $55 on every successful accommodation'
                ]
            };
        case 'gic':
            return {
                defaultTitleText: 'Get GIC',
                defaultSubTitleText: 'Simplify and speed up your students’ GIC process with us.',
                defaultIcon: React.createElement(GICV2, null),
                defaultIconContainerClass: "".concat(baseIconContainerClass, " lfc-border-primary-200 lfc-bg-primary-50"),
                defaultFeatureProposition: [
                    'Expert guidance on the entire GIC process',
                    'Fast track your application with the top banks',
                    'Earn up to CAD 125 with every successful processed GIC'
                ]
            };
        case 'flywire':
            return {
                defaultTitleText: 'Flywire Payment',
                defaultSubTitleText: 'Get a list of top colleges by raising a shortlist request to GB team',
                defaultIcon: React.createElement(GICV2, null),
                defaultIconContainerClass: "".concat(baseIconContainerClass, " lfc-border-primary-200 lfc-bg-primary-50"),
                defaultFeatureProposition: [
                    'Expert guidance on the entire GIC process',
                    'Fast track your application with the top banks',
                    'Earn up to CAD 80 with every successful processed GICs'
                ]
            };
        case 'loan':
            return {
                defaultTitleText: 'Get a Loan',
                defaultSubTitleText: 'Secure hassle-free loan options for your students.',
                defaultIcon: React.createElement(React.Fragment, null),
                defaultIconContainerClass: '',
                defaultFeatureProposition: [
                    'Guidance on the best loan options tailored for students.',
                    'Simplified documentation and faster process.',
                    'Earn up to 0.75% commission on disbursed loans'
                ]
            };
        default:
            return {
                defaultTitleText: '',
                defaultSubTitleText: '',
                defaultIcon: React.createElement(React.Fragment, null),
                defaultIconContainerClass: '',
                defaultFeatureProposition: []
            };
    }
}
export { getVasStatusTagsStyling, getVASRequestCardContent };
//# sourceMappingURL=helpers.js.map